module.exports = __webpack_public_path__ + "img/ctrl-magic-stub-mid--i.fe71b69b.svg";